import mindmap from "./mindmap";
import konvaCanvas from "./konvaCanvas";
import PvPgame from "./PvPgame";
import Molegame from "./Molegame";
import PvPTFgame from "./PvPTFgame";
import HTwbActKitHome from "./HTwbActKitHome";
import htwbcard from "./htwbcard";
import PickGame from "./PickGame";
import PunchBoard from "./PunchBoard";
import aiprompt from "./aiprompt";
export default {
  HTwbActKitHome,
  konvaCanvas,
  mindmap,
  PvPgame,
  Molegame,
  PvPTFgame,
  htwbcard,
  PickGame,
  PunchBoard,
  aiprompt,
  refreshToken: "Refresh Token",
  確定: "Confirm",
  取消: "Cancel",
  //Navigator
  測試: "Test",
  HT資源網: "HT Resource Website",
  布題頁面: "HiTeach5 Assignment Page",
  音訊: "Audio",
  影片: "Video",
  背景圖: "Background Image",
  測驗卷: "Quiz Paper",
  教材:"Tutorial",
  教案:"Plan",
  後台管理: "Admin",
  檢舉管理: "Reported Management",
  所有上傳管理: "All upload management",
  管理者後台: "Admin",
  登入: "Login",
  設定: "Settings",
  登出: "Logout",

  搜尋: "Search...",
  暫無資料: "No data available",
  推薦教材: "Recommended materials",
  的搜尋結果: "Search results for...",
  分類: "Category",
  全部: "All",
  年級: "Grade",
  科目: "subject",
  排序: "Sort",
  時間: "Time",
  標題: "Title",
  附件: "Attachment",
  無法播放的格式: "Unplayable format",
  直接下載提示字: "Currently the format cannot be previewed by the player, please download directly",

  下載: "Download",
  簡介: "Introduction",
  上傳者: "Uploader",
  相關教材: "Related Materials",
  個人簡介: "Personal Introduction",
  已貢獻教材數: "contributed",
  被管理員設置為隱藏之教材: "Hidden materials ",
  簡介文字: "Introduction Text",
  儲存: "Save",
  更新: "Update",
  語系: "Language",

  //檢舉頁面
  檢舉管理時間: "Report management - Time",
  檢舉管理教材: "Report management - Material",
  檢舉搜尋提示時間: "Search by reported uploader name, reporter name, material title field...",
  檢舉搜尋提示教材: "Search by reported uploader name, material title field",
  檢視模式: "View mode",
  按時間近到遠: "time",
  按教材ID匯總: "material ID",
  未處理: "Unprocessed",
  已處理: "Processed",
  未隱藏: "Unhidden",
  已隱藏: "Hidden",
  檢舉時間: "Report time",
  檢舉流水號: "Report serial number",
  檢舉者: "Reporter",
  檢舉代碼: "Report code",
  檢舉理由: "Report reason",
  審批狀態: "Approval status",
  審批時間: "Approval time",
  接受: "Accept",
  不受理: "Reject",
  編輯: "Edit",
  刪除: "Delete",
  刪除提示: "Delete Hint",
  刪除提示內文: "Are you sure to delete this textbook? It will not be restored after deletion!",

  一鍵接受: "Accept all",
  一鍵不受理: "Reject all",
  檢舉: "Report",

  //常用material欄位
  教材Id: "Material ID",
  類型: "Type",
  點擊數: "Clicks",
  授課語系: "Language",
  標籤: "Tags",
  隱藏: "Hidden",

  //Msg
  更新成功: "Update successful!",
  刪除成功: "Deleted successfully!",

  "reportmsg-form": {
    檢舉教材表單: "Report Material Form",
    檢舉教材名稱: "Report Material Name",
    檢舉原因: "Report Reason",
    錯誤或無法使用的檔案格式: "Error or unsupported file format",
    有害或誤導性的內容: "Harmful or misleading content",
    侵權內容: "Copyright infringement",
    其他原因: "Other reasons",
    描述: "Description",
    敘明原因提示字: "This report form will leave a record based on your login account, please be sure to explain the reason and provide the management staff to review whether it is true",
    送出: "Submit",
    取消: "Cancel",
  },
  "editmaterial-form": {
    編輯教材資訊: "Edit Material Information",
    標題: "Title",
    介紹: "Introduction",
    年級: "Grade",
    未指定: "Not specified",
    科目: "Subject",
    授課語系: "Teaching Language",
    自訂標籤: "Custom Tags",
    標籤提示字: "*Please use commas to separate tags, e.g., Linear Equations, Trigonometry",
  },
  webirs:{
     //konva畫板字串
     konvaCanvas: {
      比例: 'Scale',
      //AddImageBox
      檔案圖片: 'Local image',
      素材庫:'Cliparts',
      選取圖片作為物件: 'Select image as an object',
      背景設置: 'Background',
      選取圖片作為背景: 'Select image as background',
      //AddTextBox & TextSetting
      文字工具: 'Text Tool',
      編輯文字便利貼:'Edit',
      "openURL_NewTab": "View link in new tab",
      刪除文字便利貼:'Delete',
      複製文字便利貼:'Duplicate',
      輸入文字: 'Type text here',
      字體大小: 'Font size',
      字體顏色:'Font color',
      顏色: 'Color',
      便利貼顏色:'Sticky note color',
      確定: 'OK',
      取消: 'Cancel',
      //PenSetting
      畫筆: 'Brush',
      通用畫筆: 'Brush',
      高光筆: 'Highlighter',
      鐳射筆: 'Laser Pen',
      大小:'Size',
      //ShapeSetting
      圖形: 'Shape',
      邊框: 'Border',
      填充: 'Fill',
      箭頭: 'Arrow',
      直線: 'Line',
      圓形: 'Circle',
      橢圓: 'Ellipse',
      矩形: 'Rectangle',
      三角形: 'Triangle',
      星形: 'Star',
      所選圖片過大:'The selected image is too large (should be less than 3MB), please select again!',
      打開點擊的物件連結:'Open clicked object link?',
      多連結詢問:'The clicked object has multiple valid links, please select an action',
      目前沒有動作可復原: 'No more undo',
      復原我最近一次刪除動作:'Revert my last deletion!',
      ModifyHint: 'The content has been modified and will not be saved when you leave. Do you still want to leave?',
      物件化畫板:'Object Drawing Mode',
      重新整理圖層:'Refresh layers!',
      刪除鎖定物件提示字:'Deleted the object locked by the teacher, you can click undo button or reopen the teaching material!',
      協作無法刪除鎖定提示字:'When cowork, you cannot delete objects locked by teachers!',
      複製:'Duplicate',
      刪除:'Delete',
      移到最上層:'Move to the top',
      移到最下層:'Move to the bottom',
      回放中:'Replay...',
      暫停:'Pause',
      標準:'Normal',
      快速:'Fast',
      教師:"teacher"
    },
    mindmap:{
      新增:'New node',
      編輯:'Edit Node',
      輸入文字: 'Type something...',
      確定:'OK',
      取消:'Cancel',
      請先選取節點:'Please select the node first!',
      不可刪除有子項目的節點:'Nodes with sub-projects cannot be deleted!',
      新增失敗:'The new failed, the parent node has been deleted!',
      編輯失敗:'Editor failed, the selected node has been deleted!',
      加入根節點:'Add root node',
      左邊:'left',
      右邊:'right',
      已是最上面:'Already on top!',
      已是最下面:'Already at the bottom!',
      圖片: 'Image',
      圖片過大提示字1: 'The selected image is too large (please keep it under',
      圖片過大提示字2: 'MB). Please choose another one!',
      連結: 'Link',
      連結網址: 'Link URL',
      連結名稱: 'Link name',
      輸入URL: 'Enter URL...',
      輸入連結名稱: 'Enter link name...',
      註解: 'Annotation',
      進階設定:'Advanced Settings',
      線條顏色:'Line Color',
      節點顏色:'Node Color',
      markDownNoData: 'No valid node data after conversion!',
      markDownErr:'The provided Markdown data cannot be converted!',
      preEditHint:'Note: The previous editor of the current node is',
      confirmUpdate:', are you sure you want to modify it?',
      moveNodeTitle:'Move node',
      moveNodeHint:'Please select the parent node.',
      noTopic:'no topic',
      share:'Cloud',
      createSuccess:'MindMap created successfully, ready to jump',
      initSharingFailed:'Sharing initialization failed, please retry',
      authError:'Please retry or refresh page to update authorization',
      unexpectedError:'An unexpected error occurred, please retry',
      menu:{
        新增:'Add',
        刪除:'Delete',
        上移:'Move up',
        下移:'Move down',
        左移:'Move left',
        右移:'Move right',
        編輯:'Edit',
        複製:'Copy',
        檢視圖片:'View image',
        最後更新:'Last update',
        檢視節點變更記錄:'View node change log',
        lock:'Lock',
        unlock:'unlock',
        move:'Move',
      },
      treeMenu:{
        currentMoveNode:'The node to be moved (including child nodes)',
        selectedParentNode:'Set as parent node'
      },
      imgEditor:{
        詢問離開動作: 'Choose an action',
        保存圖片:'Save Image',
        捨棄變更:'Discard Changes',
        取消: 'Cancel',
      },
      nodeHistory:{
        節點歷史:'Node History',
        動作:'Action',
        編輯者:'Editor',
        內容:'Content',
        線條顏色:'Line Color',
        節點顏色:'Node Color',
        註解:'Annotation',
        add:'Add',
        update:'Update',
      },
      askJumpSharing: {
        title: 'Would you like to use the Sharing website for cloud-based mind mapping?',
        confirm: 'Confirm',
        cancel: 'Cancel',
      }
    }
  }
};
